import { isString } from 'lodash';

import { WindowProxy } from '@sm360/widget-commons-core-services';

class LocalStorageService {
    constructor() {
        this.storage = WindowProxy.localStorage();
    }

    get(storageKey) {
        if (!this.storage || !isString(storageKey)) {
            return '';
        }

        return this.storage.getItem(storageKey);
    }

    set(storageKey, value) {
        if (!this.storage || !isString(storageKey)) {
            return;
        }

        this.storage.setItem(storageKey, value);
    }

    delete(storageKey) {
        if (!this.storage || !isString(storageKey)) {
            return;
        }

        this.storage.removeItem(storageKey);
    }
}

export default new LocalStorageService();
